$(document).ready(function () {
    siteSearch.init();
});

var siteSearch = {};

siteSearch.initHasRun = false;

siteSearch.bindCtrl = function () {
    siteSearch.toggleCtrl.off('click').on('click', function () {
        siteSearch.toggle();
    });

    siteSearch.overlay.off('click').on('click', function () {
        siteSearch.removeActiveClasses();
        siteSearch.removeWidth();
        siteSearch.active = false;
        siteSearch.updateCookie();
    });
};

siteSearch.toggle = function () {
    if (siteSearch.view.hasClass(siteSearch.viewOpen)) {
        siteSearch.close();
        return
    };
    siteSearch.open();

};

siteSearch.open = function () {
    siteSearch.view.removeClass(siteSearch.viewClosed);
    siteSearch.view.addClass(siteSearch.viewActive);
    siteSearch.view.addClass(siteSearch.viewAnimating);
    siteSearch.overlay.addClass(siteSearch.overlayActive);
    siteSearch.addListeners();
    siteSearch.widthCheck();
    siteSearch.active = true;
    siteSearch.updateCookie();
};

siteSearch.widthCheck = function () {
    if (window.matchMedia) {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            siteSearch.animWidth(siteSearch.calcWidth(), siteSearch.openComplete);
            siteSearch.active = true;
        } else {
            siteSearch.clearWidth();
            siteSearch.active = false;
            siteSearch.openComplete();
        };
    };
    siteSearch.updateCookie();
};

siteSearch.openComplete = function () {
    siteSearch.view.addClass(siteSearch.viewOpen);
    siteSearch.view.removeClass(siteSearch.viewAnimating);
};

siteSearch.activeWidthCheck = function () {
    if (window.matchMedia) {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            siteSearch.setWidth();
            siteSearch.active = true;
        } else {
            siteSearch.clearWidth();
            siteSearch.active = false;
            siteSearch.close();
        };
    };
    siteSearch.updateCookie();
};

siteSearch.addListeners = function () {
    window.addEventListener('resize', siteSearch.activeWidthCheck, false);
};

siteSearch.close = function () {
    siteSearch.view.addClass(siteSearch.viewAnimating);
    siteSearch.view.removeClass(siteSearch.viewOpen);
    if (window.matchMedia) {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            siteSearch.animWidth(0, siteSearch.closeComplete);
        } else {
            siteSearch.closeComplete();
            siteSearch.removeWidth();
        };
    };
    siteSearch.active = false;
    siteSearch.updateCookie();
};

siteSearch.closeComplete = function () {
    siteSearch.view.removeClass(siteSearch.viewActive);
    siteSearch.overlay.removeClass(siteSearch.overlayActive);
    siteSearch.view.addClass(siteSearch.viewClosed);
    siteSearch.view.removeClass(siteSearch.viewAnimating);
};

siteSearch.calcWidth = function () {
    var leftMarginMin = 140,
        leftMarginMax = 400,
        leftMarginRange = leftMarginMax - leftMarginMin,

        windowMediaPoint = 1024,
        windowMax = 1920,
        windowRange = windowMax - windowMediaPoint,
        windowRangePosition = window.innerWidth - windowMediaPoint,

        rightOpts = siteSearch.headerOpts[0].scrollWidth + 17,
        leftOpts = siteSearch.headerLeft[0].scrollWidth + 17;

    if (windowRangePosition > windowRange) {
        windowRangePosition = windowRange
    };
    if (windowRangePosition < 0) {
        windowRangePosition = 0
    };
    var leftMargin = leftMarginMin + windowRangePosition * (leftMarginRange / windowRange);
    return window.innerWidth - rightOpts - leftOpts - leftMargin;
};

siteSearch.setWidth = function () {
    siteSearch.view.css({
        width: siteSearch.calcWidth() + 'px'
    })
};

siteSearch.animWidth = function (value, callbackFn) {
    siteSearch.widthCalculation = value;
    siteSearch.view.animate({
        width: value + 'px'
    }, 500, function () {
        if (callbackFn) {
            callbackFn()
        };
    });
};

siteSearch.removeWidth = function () {
    siteSearch.widthCalculation = 0;
    siteSearch.view.css('width', siteSearch.widthCalculation);
};

siteSearch.clearWidth = function () {
    siteSearch.widthCalculation = '';
    siteSearch.view.css('width', siteSearch.widthCalculation);
};

siteSearch.updateCookie = function () {
    var calc = siteSearch.widthCalculation;

    if (calc !== '') {
        calc += 'px';
    };

    var obj = {
        viewClass: siteSearch.viewActive,
        viewOpenClass: siteSearch.viewOpen,
        viewClosedClass: siteSearch.viewClosed,
        overlayClass: siteSearch.overlayActive,
        width: calc,
        active: siteSearch.active
    };

    logicjs.setCookie('siteSearch', JSON.stringify(obj));
};

siteSearch.activeSearchCheck = function () {
    if (siteSearch.view.hasClass(siteSearch.viewActive)) {
        siteSearch.active = true;
        siteSearch.addListeners();
    };
};

siteSearch.init = function () {
    if (siteSearch.initHasRun) return;
    siteSearch.container = $('.c-site-search');
    siteSearch.overlay = $('.c-site-search-overlay');
    siteSearch.headerLeft = $('.site-header__left');
    siteSearch.headerOpts = $('.c-options-dropdown');

    siteSearch.view = siteSearch.container.find('.c-site-search__view');
    siteSearch.toggleCtrl = siteSearch.container.find('.c-site-search__toggle');

    siteSearch.viewOpen = 'c-site-search__view--open';
    siteSearch.viewClosed = 'c-site-search__view--closed';
    siteSearch.viewActive = 'c-site-search__view--active';
    siteSearch.viewAnimating = 'c-site-search__view--animating';
    siteSearch.overlayActive = 'c-site-search-overlay--active';

    siteSearch.activeSearchCheck();
    siteSearch.bindCtrl();
    siteSearch.initHasRun = true;
};